module.exports = __webpack_public_path__ + "img/logo4.46e6b164.png";